import { Component } from "@angular/core";
import { NavController,ViewController, NavParams} from "ionic-angular";
import { StorageProvider } from "../../providers/storage-service/storage-service";

@Component({
    selector: 'edit-athlete-data',
    templateUrl: 'edit-athlete-data.html',
})

export class EditAthleteData{

    athleteData;

    constructor(private navCtrl: NavController,
            private navParams: NavParams,
            private storageService: StorageProvider,
            private viewCtrl: ViewController){
        this.getData();
    }

    getData(){
        this.athleteData = this.navParams.get("ath");
        console.log("athlete edit"+JSON.stringify(this.athleteData));
    }
    onBackMenu(){
    this.viewCtrl.dismiss(this.athleteData);
    // this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// /src/pages/edit-athlete-data/edit-athlete-data.ts